import Translatable from '../translatable_text/Translatable';

function Brands() {


  return (
    <section className="brands-crev simple section-padding">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-wrap">
        <div className="w-full lg:w-5/12 offset-lg-1x md-hidex ">
            <div className="sec-head nocurve">
              <div className="ontop d-rotate wow">
                <h2 className="sub-title main-color mb-15 rotate-text">
                  <Translatable>
                    Special Thanks To
                  </Translatable>
                </h2>
                <h3 className="ltr:hidden fw-600 text-u ls1">
                  جميع شركائنا  <span className="fw-200">الاستراتيجيين</span>
                </h3>
                <h3 className="rtl:hidden fw-600 text-u ls1">
                  All our <span className="fw-200">partners</span>
                </h3>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-6/12  mt-100 md:order-2">
            <div className="flex flex-wrap  d-rotate wow">
              <div className="w-full  md:w-1/2 item ontop">
                <div className="w-full img flex items-center justify-center ">
                  <img className='rotate-text' src="/light/assets/imgs/logo/begining-logo.webp" alt="logo" width="100%" height="100%" loading='lazy'/>
                </div>
                <span className="top-left">
                  <svg
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-23 2xl:w-[3.2rem] h-auto"
                  >
                    <rect
                      y="11"
                      width="23"
                      height="0.671958"
                      fill="white"
                    ></rect>
                    <rect
                      x="12"
                      width="23"
                      height="0.671957"
                      transform="rotate(90 12 0)"
                      fill="white"
                    ></rect>
                  </svg>
                </span>
                <span className="top-right">
                  <svg
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-23 2xl:w-[3.2rem] h-auto"
                  >
                    <rect
                      y="11"
                      width="23"
                      height="0.671958"
                      fill="white"
                    ></rect>
                    <rect
                      x="12"
                      width="23"
                      height="0.671957"
                      transform="rotate(90 12 0)"
                      fill="white"
                    ></rect>
                  </svg>
                </span>
                <span className="bottom-left">
                  <svg
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-23 2xl:w-[3.2rem] h-auto"
                  >
                    <rect
                      y="11"
                      width="23"
                      height="0.671958"
                      fill="white"
                    ></rect>
                    <rect
                      x="12"
                      width="23"
                      height="0.671957"
                      transform="rotate(90 12 0)"
                      fill="white"
                    ></rect>
                  </svg>
                </span>
                <span className="bottom-right">
                  <svg
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-23 2xl:w-[3.2rem] h-auto"
                  >
                    <rect
                      y="11"
                      width="23"
                      height="0.671958"
                      fill="white"
                    ></rect>
                    <rect
                      x="12"
                      width="23"
                      height="0.671957"
                      transform="rotate(90 12 0)"
                      fill="white"
                    ></rect>
                  </svg>
                </span>
              </div>

              <div className="w-full  md:w-1/2 item">
                <div className="img flex items-center justify-center ">
                  <img className='rotate-text' src="/light/assets/imgs/logo/sol-data-logo.webp" alt="img" width="100%" height="100%" loading='lazy'/>
                </div>
                <span className="top-right">
                  <svg
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-23 2xl:w-[3.2rem] h-auto"
                  >
                    <rect
                      y="11"
                      width="23"
                      height="0.671958"
                      fill="white"
                    ></rect>
                    <rect
                      x="12"
                      width="23"
                      height="0.671957"
                      transform="rotate(90 12 0)"
                      fill="white"
                    ></rect>
                  </svg>
                </span>
              </div>
              <div className="w-full  md:w-1/2 item">
                <div className="img flex items-center justify-center ">
                  <img className='rotate-text' src="/light/assets/imgs/logo/uc-tech-logo.webp" alt="img" width="100%" height="100%" loading='lazy'/>
                </div>
                <span className="top-right">
                  <svg
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-23 2xl:w-[3.2rem] h-auto"
                  >
                    <rect
                      y="11"
                      width="23"
                      height="0.671958"
                      fill="white"
                    ></rect>
                    <rect
                      x="12"
                      width="23"
                      height="0.671957"
                      transform="rotate(90 12 0)"
                      fill="white"
                    ></rect>
                  </svg>
                </span>
              </div>
              <div className="w-full  md:w-1/2 item">
                <div className="img flex items-center justify-center ">
                  <img className='rotate-text' src="/light/assets/imgs/logo/arob.webp" alt="img" width="100%" height="100%" loading='lazy'/>
                </div>
                <span className="top-right">
                  <svg
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-23 2xl:w-[3.2rem] h-auto"
                  >
                    <rect
                      y="11"
                      width="23"
                      height="0.671958"
                      fill="white"
                    ></rect>
                    <rect
                      x="12"
                      width="23"
                      height="0.671957"
                      transform="rotate(90 12 0)"
                      fill="white"
                    ></rect>
                  </svg>
                </span>
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </section>
  );
}

export default Brands;
